<template>
    <div
        v-if="success !== null && success !== undefined"
        class="alert alert-success dismissable"
        role="alert"
    >
        {{ success }}
        <button type="button" class="close" aria-label="Close" @click="clearSuccess">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</template>

<script>
    export default {
        computed: {
            success() {
                return this.$store.getters.success
            }
        },

        methods: {
            clearSuccess() {
                this.$store.dispatch('clearSuccess')
            }
        }
    }
</script>